(function () {
  var SECTION_SELECTOR = '[data-gfs-section]';
  var MOBILE_MEDIA = window.matchMedia('(max-width: 749px)');
  var sectionState = new WeakMap();

  function parseJSON(value) {
    try {
      return JSON.parse(value || '{}');
    } catch (e) {
      console.warn('[GFS] failed to parse JSON', e, value);
      return {};
    }
  }

  function getSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    return Array.prototype.slice.call(scope.querySelectorAll(SECTION_SELECTOR));
  }

  function getEmbed(section) {
    if (!section) return null;
    return section.querySelector('shopify-forms-embed');
  }

  function getConsentContainer(embed) {
    if (!embed || !embed.shadowRoot) return null;

    return (
      embed.shadowRoot.querySelector('div._consentCheckboxContainer_cit2d_49') ||
      embed.shadowRoot.querySelector('[class*="consentCheckboxContainer"]')
    );
  }

  function setVars(embed, vars) {
    Object.keys(vars).forEach(function (key) {
      var nextValue = vars[key];
      if (embed.style.getPropertyValue(key) !== nextValue) {
        embed.style.setProperty(key, nextValue);
      }
    });
  }

  function applyConsentStyles(embed) {
    var consent = getConsentContainer(embed);
    if (!consent) return false;

    consent.style.setProperty('order', '2', 'important');

    return true;
  }

  function applySection(section) {
    if (!section) return false;

    var embed = getEmbed(section);
    if (!embed) return false;

    var desktopVars = parseJSON(section.getAttribute('data-gfs-desktop'));
    var mobileVars = parseJSON(section.getAttribute('data-gfs-mobile'));

    setVars(embed, desktopVars);

    if (MOBILE_MEDIA.matches) {
      setVars(embed, mobileVars);
    }

    applyConsentStyles(embed);

    return true;
  }

  function clearSectionTimer(section) {
    var state = sectionState.get(section);
    if (!state) return;

    if (state.timer) {
      clearInterval(state.timer);
    }

    sectionState.delete(section);
  }

  function bootSection(section) {
    if (!section) return;

    clearSectionTimer(section);

    var tries = 0;
    var maxTries = 20;

    var timer = setInterval(function () {
      tries += 1;

      var applied = applySection(section);
      if (applied || tries >= maxTries) {
        clearSectionTimer(section);
      }
    }, 250);

    sectionState.set(section, { timer: timer });
  }

  function bootAll(root) {
    getSections(root).forEach(function (section) {
      bootSection(section);
    });
  }

  function applyAll(root) {
    getSections(root).forEach(function (section) {
      applySection(section);
    });
  }

  function handleSectionEvent(event) {
    var target = event && event.target ? event.target : null;

    if (target && target.matches && target.matches(SECTION_SELECTOR)) {
      bootSection(target);
      return;
    }

    if (target && target.querySelectorAll) {
      var nestedSections = getSections(target);
      if (nestedSections.length) {
        nestedSections.forEach(function (section) {
          bootSection(section);
        });
        return;
      }
    }

    bootAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootAll(document);
    });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', handleSectionEvent);
  document.addEventListener('shopify:section:reorder', function () {
    bootAll(document);
  });
  document.addEventListener('shopify:block:select', function () {
    bootAll(document);
  });

  window.addEventListener('resize', function () {
    applyAll(document);
  });
})();